/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupCreate
 */
export interface UserGroupCreate {
    /**
     * 
     * @type {string}
     * @memberof UserGroupCreate
     */
    label: string;
    /**
     * Create `UserGroupAssignment`s for these users.
     * @type {Array<string>}
     * @memberof UserGroupCreate
     */
    userIds?: Array<string> | null;
    /**
     * Create `UserGroupVehicleGroupAssignment`s for these vehicle groups.
     * @type {Array<string>}
     * @memberof UserGroupCreate
     */
    vehicleGroupIds?: Array<string> | null;
}

/**
 * Check if a given object implements the UserGroupCreate interface.
 */
export function instanceOfUserGroupCreate(value: object): value is UserGroupCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function UserGroupCreateFromJSON(json: any): UserGroupCreate {
    return UserGroupCreateFromJSONTyped(json, false);
}

export function UserGroupCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'userIds': json['userIds'] == null ? undefined : json['userIds'],
        'vehicleGroupIds': json['vehicleGroupIds'] == null ? undefined : json['vehicleGroupIds'],
    };
}

export function UserGroupCreateToJSON(json: any): UserGroupCreate {
    return UserGroupCreateToJSONTyped(json, false);
}

export function UserGroupCreateToJSONTyped(value?: UserGroupCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'userIds': value['userIds'],
        'vehicleGroupIds': value['vehicleGroupIds'],
    };
}

